import React from "react";
import { ShieldCheck, KeyRound, Landmark, FileCheck2, Lock, Handshake } from "lucide-react";

const ITEMS = [
  {
    icon: KeyRound,
    title: "e-Devlet şifrenizi istemeyiz",
    text: "Kimlik doğrulaması veya devlet sistemi girişi yapmıyoruz.",
  },
  {
    icon: Lock,
    title: "Banka şifrenizi istemeyiz",
    text: "Ödeme veya banka hesap bilgilerinize erişim talep etmiyoruz.",
  },
  {
    icon: Landmark,
    title: "Resmi kurum değiliz",
    text: "Abonelik İptal bağımsız bir tüketici işlem asistanıdır.",
  },
  {
    icon: FileCheck2,
    title: "Metinleri siz kontrol edersiniz",
    text: "Hazırlanan başvuru metnini göndermeden önce her zaman siz onaylarsınız.",
  },
  {
    icon: ShieldCheck,
    title: "Belgeleriniz sadece başvurunuz için",
    text: "Yüklediğiniz belgeleri yalnızca başvurunuzu hazırlamak için kullanırız.",
  },
  {
    icon: Handshake,
    title: "Hukuki danışmanlık değildir",
    text: "Abonelik İptal size süreçte yol gösterir, avukatınız yerine geçmez.",
  },
];

export default function TrustSection() {
  return (
    <section
      data-testid="trust-section"
      className="fs-wide-container mt-24 md:mt-32"
    >
      <div className="max-w-2xl">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#4DA6A1] mb-3">
          Güven & Şeffaflık
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-[#0F3D4A] tracking-tight">
          Yalın kurallar. Şifresiz süreç.
        </h2>
        <p className="mt-3 text-[#0F3D4A]/70 max-w-xl leading-relaxed">
          Abonelik İptal, tüketicinin başvurusunu hızlandırır — resmi kurumların ve
          bankaların yerine geçmez. Süreç boyunca ne yaptığımızı ve ne
          yapmadığımızı açıkça belirtiriz.
        </p>
      </div>
      <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {ITEMS.map((it, i) => {
          const Icon = it.icon;
          return (
            <div
              key={i}
              data-testid={`trust-item-${i}`}
              className="fs-card p-6 md:p-7"
            >
              <div className="w-12 h-12 rounded-2xl bg-slate-100 flex items-center justify-center mb-4">
                <Icon size={22} strokeWidth={2.25} className="text-[#0F3D4A]" />
              </div>
              <h3 className="text-lg font-semibold text-[#0F3D4A] mb-1.5">
                {it.title}
              </h3>
              <p className="text-sm text-[#0F3D4A]/70 leading-relaxed">
                {it.text}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
